module.exports = __webpack_public_path__ + "dc4ac92785adc71e37f0e0c16fbbe6c3.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-bold.ttf
// module id = 33
// module chunks = 0 1 2 3 4 5 6 7 8 9